import { apiRequest } from '../http.js'

export const tenantPeopleApi = {
archive: async (userId, options = {}) => {
      const data = await apiRequest(`/tenant/people/${userId}/archive`, { ...options, method: 'POST' })
      return data.person
    },
    restore: async (userId, options = {}) => {
      const data = await apiRequest(`/tenant/people/${userId}/restore`, { ...options, method: 'POST' })
      return data.person
    },
}
